import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from 'semantic-ui-react';
import MoreVert from '@material-ui/icons/MoreVert';
import './dashboard.css';
import Server from '../../functions/server'
import $ from "jquery";
import Dialogbox from './dialogbox';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Loading from '../loading';
import Release from '../../functions/release';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';


class Sales extends React.Component {

  state = {
    data: [],
    open: false
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){ dd = '0' + dd; }
    if(mm < 10){ mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  startingMonth() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10) { dd = '0' + dd; }
    if(mm < 10) { mm = '0' + mm; }
    let fromMonth = yyyy+'-'+mm+'-01';
    return fromMonth;
  }

  startingYear() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){
      dd = '0' + dd;
    }
    if (mm < 3) {
      yyyy = yyyy - 1;
    }
    if(mm < 10){
        mm = '0' + mm;
    }
    let fromYear = yyyy+'-04-01';
    return fromYear;
  }


  viewBranch(type) {
    let context = this;
    let today = this.getToday();
    let startingMonth = this.startingMonth();
    let staringYear = this.startingYear();
    context.setState({ load: true, message: 'Getting Values' })
    $.ajax({
      type: 'POST',
      data: { 'today': today, 'startingMonth': startingMonth, 'staringYear': staringYear, 'type': type },
      url: Server() + 'dashboard/salesbranch.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data: data, open: true, load: false })
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  handleClick = () => {
    this.setState({ salesopen: true })
  }


  render() {
    let todaySales, yesterdaySales, monthlySales, yearlySales, overallSales;
    let data = this.props.data.map((z) => {
      todaySales = z.today_sales;
      yesterdaySales = z.yesterday_sales;
      monthlySales = z.month_sales;
      yearlySales = z.year_sales;
      overallSales = z.overall_sales;
    })
    if (todaySales == null) { todaySales = 0; }
    if (yesterdaySales == null) { yesterdaySales = 0; }
    if (monthlySales == null) { monthlySales = 0; }
    if (yearlySales == null) { yearlySales = 0; }
    if (overallSales == null) { overallSales = 0; }
    todaySales = Number(todaySales);
    yesterdaySales = Number(yesterdaySales);
    monthlySales = Number(monthlySales);
    yearlySales = Number(yearlySales);
    overallSales = Number(overallSales);
    todaySales = todaySales.toFixed(2);
    yesterdaySales = yesterdaySales.toFixed(2);
    monthlySales = monthlySales.toFixed(2);
    yearlySales = yearlySales.toFixed(2);
    overallSales = overallSales.toFixed(2);
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={12}>
            <Card style={{backgroundColor: '#abb119'}}>
              <div style={{paddingTop: '2%', paddingLeft: '2%'}}>
                <div style={{fontSize: 17, color: 'white', display: 'flex'}}>
                  <b>Sales</b>
                  <u style={{marginLeft: '2%'}}>
                    <Link to={"/"+Release()+"/chart-dashboard"}>
                    <Button size="small" style={{color: 'white'}}>View In Chart</Button>
                    </Link>
                  </u>
                </div>
              </div>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Link to={"/"+Release()+"/place-order"}>
                    <CardContent>
                        <div style={{color: 'white'}}>Today<br/></div>
                        <b style={{color: 'white', paddingTop: '94%', fontSize: 15}}>{'₹'+todaySales}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'today')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Link to={"/"+Release()+"/place-order"}>
                    <CardContent>
                      <div style={{color: 'white'}}>Yesterday<br/></div>
                      <b style={{color: 'white', paddingTop: '4%', fontSize: 15}}>{'₹'+yesterdaySales}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'yesterday')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Link to={"/"+Release()+"/place-order"}>
                    <CardContent>
                      <div style={{color: 'white'}}>This Month<br/></div>
                      <b style={{color: 'white', paddingTop: '4%', fontSize: 15}}>{'₹'+monthlySales}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'month')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Link to={"/"+Release()+"/place-order"}>
                    <CardContent>
                      <div style={{color: 'white'}}>This Fina. Yr<br/></div>
                      <b style={{color: 'white', paddingTop: '4%', fontSize: 15}}>{'₹'+yearlySales}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'year')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
              </Grid>
            </Card>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <Link to={"/"+Release()+"/customer-statement"}>
            <Card style={{backgroundColor: '#abb119', cursor: 'pointer'}}>
                <div style={{fontSize: 17, color: 'white', padding: '5%'}}><b>Balance</b></div>
                <br/>
              <CardContent>
                <center><b style={{color: 'white', paddingTop: '4%', paddingBottom: '3%', fontSize: 18}}>{'₹'+overallSales}</b></center>
              </CardContent>
              <br/><br/>
            </Card>
            </Link>
          </Grid.Column>
        </Grid>
        { this.state.open ?
          (
            <div><Dialogbox col2="Branch" col3="Amount" type="amount" handleClose={ () => { this.setState({ open: false }) }} open={this.state.open} data={this.state.data} title="Sales Report" /></div>
          ):
          (
            <div></div>
          )
        }
      </div>
    );
  }
}

export default Sales;
